const BLOCKS_HEIGHT = $('.header').height() + $('.iyarn-business_school-hero').height() + $('.leading-companies').height() + $('.benefits-business').height();

$(document).scroll(function () {
    let y = $(this).scrollTop();
    if (y > BLOCKS_HEIGHT && !getCookie('bannerShowed')) {
        $('#exampleModal').modal('show');
        setCookie('bannerShowed', 1, 14);
    }
});


function setCookie(name, value, daysToLive) {
    let cookie = name + "=" + encodeURIComponent(value);
    if (typeof daysToLive === "number") {
        cookie += "; max-age=" + (daysToLive * 24 * 60 * 60);
        document.cookie = cookie;
    }
}

function getCookie(name) {
    let cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        if (name === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}
